import { apiContext } from "./apiContext";

export const ApiProvider = apiContext.Provider;
